import { render, staticRenderFns } from "./OperaVisitsDesWindow.vue?vue&type=template&id=2672b33a&scoped=true&"
import script from "./OperaVisitsDesWindow.vue?vue&type=script&lang=js&"
export * from "./OperaVisitsDesWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaVisitsDesWindow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OperaVisitsDesWindow.vue?vue&type=style&index=1&id=2672b33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672b33a",
  null
  
)

export default component.exports